import { render, staticRenderFns } from "./FirstPage.vue?vue&type=template&id=00cc693a&"
import script from "./FirstPage.vue?vue&type=script&lang=js&"
export * from "./FirstPage.vue?vue&type=script&lang=js&"
import style0 from "./FirstPage.vue?vue&type=style&index=0&id=00cc693a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports